<form [formGroup]="brandFormGroup" style="height:100%">
  <div class="dashboard-tile">
    <div class="tile-header">
      <div *ngIf="_brand?.id" class="tile-header-title">Update Report Brand <span class="text-primary">{{_brand.name}}</span></div>
      <div *ngIf="!_brand?.id" class="tile-header-title">New Report Brand</div>
    </div>
    <div class="tile-content">
      <app-grid-spinner #spinner></app-grid-spinner>
      <div style="width:60%; max-width:600px; height:inherit; display:inline-block; vertical-align:top; padding-right:20px;">
        <mat-tab-group style="height: inherit;">
          <mat-tab label="Report Title Page">
            <div style="margin: 10px auto;">
              <div style="display: inline-block; max-width: 70%; vertical-align: top;">
                Report images should have a resolution of 2550x3300 (8.5" x 11" at 300dpi). A photoshop template to assist in creating the image can be accessed <a href="/assets/report/custom-title-page-template.psd" target="_blank">here</a>. Uploaded files should be .JPG or .PNG.
              </div>
              <div style="display: inline-block; min-width:150px; text-align:right; vertical-align: top;">
                <button class="small" id="titlePageImageBtn" mat-raised-button type="button" color="primary" (click)="fileInput3.click()">
                  <mat-icon>cloud_upload</mat-icon> Upload Image
                </button>
                <input hidden type="file" #fileInput3 accept="image/*" (change)="imageChange('Title', $event);" />
              </div>
            </div>
            <img *ngIf='_brand.documentTitlePage' id="titlePageImage" class="sample-report" [src]='_brand.documentTitlePage'>
          </mat-tab>
          <mat-tab label="Report Content Page">
            <div style="margin: 10px auto;">
              <div style="display: inline-block; max-width: 70%; vertical-align: top;">
                Report images should have a resolution of 2550x3300 (8.5" x 11" at 300dpi). A photoshop template to assist in creating the image can be accessed <a href="/assets/report/custom-content-page-template.psd" target="_blank">here</a>. Uploaded files should be .JPG or .PNG.
              </div>
              <div style="display: inline-block; min-width:150px; text-align:right; vertical-align: top;">
                <button class="small" id="contentPageImageBtn" mat-raised-button type="button" color="primary" (click)="fileInput4.click()">
                  <mat-icon>cloud_upload</mat-icon> Upload Image
                </button>
                <input hidden type="file" #fileInput4 accept="image/*" (change)="imageChange('Content', $event);" />
              </div>
            </div>
            <img *ngIf='_brand.documentPageHeader' id="pageHeaderImage" class="sample-report" [src]='_brand.documentPageHeader'>
          </mat-tab>
        </mat-tab-group>
      </div>
      <div class="formFieldList" style="width:30%; display:inline-block; vertical-align:top; padding-top: 20px;">
        <mat-form-field>
          <input matInput class="color-element"
                  placeholder="Base Color"
                  formControlName="baseColor"
                  [value]="_brand.baseColor"
                  [style.background]="_brand.baseColor"
                  (click)="toggle=true; selectedColor='baseColor'; selectedName='Base Color'; showColors=true; showPatterns=false">
        </mat-form-field>
        <mat-form-field>
          <input matInput class="color-element"
                  placeholder="Highlight Color"
                  formControlName="highlightColor"
                  [value]="_brand.highlightColor"
                  [style.background]="_brand.highlightColor"
                  (click)="toggle=true; selectedColor='highlightColor'; selectedName='Highlight Color'; showColors=true; showPatterns=false">
        </mat-form-field>
        <mat-form-field>
          <input matInput class="color-element"
                  placeholder="Text Background Color"
                  formControlName="textBackgroundColor"
                  [value]="_brand.textBackgroundColor"
                  [style.background]="_brand.textBackgroundColor"
                  (click)="toggle=true; selectedColor='textBackgroundColor'; selectedName='Text Background Color'; showColors=true; showPatterns=false">
        </mat-form-field>
        <div *ngIf="showColors" style="width:300px; display:inline-block; vertical-align:top; padding-left:20px; padding-top:25px">
          <div>{{ selectedName }}</div>
          <span *ngIf="showColors"
                [style.background]="_brand[selectedColor]"
                [cpToggle]="true"
                [cpDialogDisplay]="'inline'"
                [cpCancelButton]="true"
                (cpSliderChange)="colorChange('spSliderChange')"
                cpAlphaChannel="disabled"
                [(colorPicker)]="_brand[selectedColor]"></span>
        </div>
      </div>

      <div class="tile-footer">
        <button mat-raised-button type="button" color="primary" [disabled]="brandFormGroup.invalid" (click)="save()">Save</button>
        <button *ngIf="_brand?.id" mat-raised-button type="button" color="primary" (click)="revertToDefault()">{{getRevertButtonText()}}</button>
        <button mat-raised-button type="button" color="primary" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </div>
</form>
